import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Mission } from "@/components/Mission";
import { Method } from "@/components/Method";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-zinc-50 font-body text-zinc-900 antialiased selection:bg-zinc-900 selection:text-white">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Mission />
          <Method />
          <Services />
          <WhyUs />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
